import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleDisciplineEducationalFormCountry extends TitleBase {
	private disciplineValue: string;
	private educationalFormValue: string;
	private countryValue: string;

	protected canHandle(): boolean {
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);
		this.educationalFormValue = this.getFilterValue(ParameterType.EDUCATIONAL_FORM);
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);

		return (
			this.indexableFilters.length === 3 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.indexableFilters.some((_) => _.type === ParameterType.EDUCATIONAL_FORM) &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY)
		);
	}

	protected getPageTitle(): string {
		return `${this.disciplineValue} ${this.educationalFormValue} in ${this.countryValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(
			`${this.educationalFormValue} ${this.titlePortalType} in the field of ${this.disciplineValue}`,
			` in ${this.countryValue}`,
		);
	}
}
